import React from "react";
import { ChecMark } from "@/assets/icons";
import cls from "./styles.module.scss";

interface SurveyCheckboxProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export const SurveyCheckbox: React.FC<SurveyCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange();
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`${cls.checkbox} ${checked && cls.checkboxActive} ${
        disabled && cls.checkboxDisabled
      }`}
    >
      {checked && <ChecMark />}
    </div>
  );
};
